import React from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';
import { SessionState } from '../DashboardHeader/ISearch';

interface ProcessingProgressProps {
  status: SessionState;
  processedMs: number;
  recordedMs: number;
}

const ProcessingProgress: React.FC<ProcessingProgressProps> = ({ status, processedMs, recordedMs }) => {
  // Only show progress for processing states
  const isProcessing =
    status === SessionState.INITIALIZING || status === SessionState.IN_QUEUE || status === SessionState.IN_PROGRESS;

  if (!isProcessing || recordedMs === 0) {
    return null;
  }

  const percentage = Math.min((processedMs / recordedMs) * 100, 100);

  return (
    <Box sx={{ width: '100%', mt: 1, pb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="caption" sx={{ fontSize: '10px', color: '#707070' }}>
          {percentage.toFixed(1)}%
        </Typography>
        <Typography variant="caption" sx={{ fontSize: '10px', color: '#707070' }}>
          {Math.floor(processedMs / 1000)}s / {Math.floor(recordedMs / 1000)}s
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
            backgroundColor: '#2B8DFF',
          },
        }}
      />
    </Box>
  );
};

export default ProcessingProgress;
